// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "*[data-v-dcb81022]{will-change:height;transform:translateZ(0);backface-visibility:hidden;perspective:1000px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
